'use client';

import BaseModal from '@c/modals/BaseModal';
import OfferOperationContent from './OfferOperationContent';
import { OfferDocument } from 'models/offer';

interface OfferOperationModalProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  onClose: () => void;
  type: 'counter' | 'accept' | 'decline';
  offer: OfferDocument;
}

export default function OfferOperationModal({
  isOpen,
  onClose,
  type,
  offer,
}: OfferOperationModalProps) {
  return (
    <BaseModal isOpen={isOpen} hideCloseIcon dismiss={onClose}>
      <OfferOperationContent
        type={type}
        offer={offer}
        onClose={onClose}
        showTitle={true}
        hideCloseButton={false}
      />
    </BaseModal>
  );
}
